// @ts-nocheck
import { MOCK, invalidateAndRefresh } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api, packagesApi, adminApi } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// __legacy_global_aliases__
// Resolve cross-module helpers via window (legacy SPA globals)
const getShareRegionCountrySelection = (...args: any[]) => (window as any).getShareRegionCountrySelection(...args);


// ============================================================
// 包体相关 + 创建包体
// ============================================================

window.Pages = window.Pages || {};

function getPackageCreateRegionSelection() {
  if (typeof getShareRegionCountrySelection === "function") return getShareRegionCountrySelection();
  return { global: true, regions: ["GLOBAL"], countries: [] };
}

function getPackageCreateRegionSummaryText(selection = getPackageCreateRegionSelection()) {
  if (selection.global) return "GLOBAL · 全球";
  const regionCodes = (selection.regions || []).filter((code) => code !== "GLOBAL");
  const countryCodes = selection.countries || [];
  const codes = [...regionCodes, ...countryCodes];
  if (!codes.length) return "GLOBAL · 全球";
  if (codes.length > 1) return `已选 ${regionCodes.length} 个区域 / ${countryCodes.length} 个国家`;
  const code = codes[0];
  const region = (typeof window.getShareRegionCountryGroups === "function" ? window.getShareRegionCountryGroups() : []).find((item) => item.code === code);
  const country = (typeof window.getShareCountryOptions === "function" ? window.getShareCountryOptions() : []).find((item) => item.code === code);
  const target = region || country;
  return `${code} · ${target?.zhName || target?.name || code}`;
}

function getPackageCreateRegionFromSelection(selection = getPackageCreateRegionSelection()) {
  const resolveRegionName = typeof window.regionNameFromCode === "function" ? window.regionNameFromCode : (code) => code;
  if (selection.global) return { region: "GLOBAL", regionName: resolveRegionName("GLOBAL") || "Global / 全球" };
  const regionCodes = (selection.regions || []).filter((code) => code !== "GLOBAL");
  const countryCodes = selection.countries || [];
  const codes = [...regionCodes, ...countryCodes];
  if (!codes.length) return { region: "GLOBAL", regionName: resolveRegionName("GLOBAL") || "Global / 全球" };
  if (codes.length === 1) return { region: codes[0], regionName: resolveRegionName(codes[0]) || codes[0] };
  return { region: codes.join(","), regionName: `已选 ${regionCodes.length} 个区域 / ${countryCodes.length} 个国家` };
}

Pages.packageCreate = function (gameId) {
  const game = gameId ? MOCK.GAMES.find((g) => g.id === gameId) : null;
  const fromMenu = !gameId; // 从顶层菜单进入需要选择游戏
  const cancelPath = gameId ? `/dev/games/${gameId}` : "/dev/packages";
  const successPath = gameId ? `/dev/games/${gameId}?tab=packages` : "/dev/packages";
  const regionSelection = getPackageCreateRegionSelection();
  return `
    ${UI.pageHeader({ title: game ? `为「${game.name}」添加包体` : "创建包体", desc: "Region × Platform 的组合，是配置的最小粒度；包体共享所属游戏的 GameID 与 Game Secret" })}

    <div class="max-w-6xl">
      <div class="grid grid-cols-12 gap-5 items-start">
        <div class="col-span-8">
          <form onsubmit="return submitPackageCreate(event, '${gameId || ""}', '${successPath}')" class="space-y-4">
            <div class="card overflow-hidden">
              <div class="px-5 py-4 border-b border-ink-100 bg-gradient-to-r from-brand-50 to-white">
                <div class="flex items-center gap-3">
                  <div class="w-9 h-9 rounded-lg bg-brand-900 text-white flex items-center justify-center">
                    ${Icon.package({ size: 17, color: "#fff" })}
                  </div>
                  <div>
                    <h3 class="text-sm font-semibold text-ink-900">包体基础信息</h3>
                    <p class="text-xs text-ink-500 mt-0.5">填写运营可识别的包体名称，选择发行区域和发布平台；系统仅自动生成 Ripple ID。</p>
                  </div>
                </div>
              </div>

              <div class="p-5 space-y-5">
                ${fromMenu ? `
                <div>
                  <label class="block text-sm font-medium text-ink-700 mb-1.5">选择游戏 <span class="text-red-500">*</span></label>
                  <select id="package-game-id" required class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100">
                    <option value="">请选择游戏</option>
                    ${MOCK.GAMES.map((g) => `<option value="${g.id}">${g.icon} ${g.name}（${g.code}）</option>`).join("")}
                  </select>
                  <p class="text-xs text-ink-500 mt-1.5">包体会继承所选游戏的 GameID 与 Game Secret。</p>
                </div>
                ` : `
                <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-3 flex items-center justify-between">
                  <div class="flex items-center gap-2.5">
                    <span class="text-lg">${game?.icon || ""}</span>
                    <div>
                      <div class="text-sm font-semibold text-ink-900">${game?.name || "当前游戏"}</div>
                      <div class="text-xs text-ink-500 font-mono">${game?.code || game?.id || ""}</div>
                    </div>
                  </div>
                  <span class="badge bg-brand-50 text-brand-700">继承游戏凭证</span>
                </div>
                `}

                <div>
                  <label class="block text-sm font-medium text-ink-700 mb-1.5">包体名称 <span class="text-red-500">*</span></label>
                  <input id="package-name" type="text" required maxlength="60" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100" placeholder="如：王者征途 US iOS 正式包" />
                  <p class="text-xs text-ink-500 mt-1.5">由研发录入运营可理解的展示名称，后续包体管理、分享配置和数据报表都会展示该名称。</p>
                </div>

                <div class="grid grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-ink-700 mb-1.5">国家/区域 (Region) <span class="text-xs text-ink-400 font-normal">（可选）</span></label>
                    <button type="button" onclick="navigate('/admin/platform/regions-countries?return=' + encodeURIComponent(getCurrentPathWithQuery()))" class="w-full px-3 py-2.5 rounded-lg border border-ink-200 bg-white hover:border-brand-300 hover:bg-brand-50/30 text-left transition flex items-center justify-between gap-3">
                      <span class="min-w-0 truncate text-sm text-ink-900">${getPackageCreateRegionSummaryText(regionSelection)}</span>
                      <span class="text-ink-400 text-xs">⌄</span>
                    </button>
                    <p class="text-xs text-ink-500 mt-1.5">点击下拉框进入统一国家区域页面选择，未选择时默认 GLOBAL。</p>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-ink-700 mb-1.5">平台 (Platform) <span class="text-red-500">*</span></label>
                    <select id="package-platform" required onchange="updatePackageAppIdLabel(this.value)" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100">
                      <option value="">请选择平台</option>
                      ${(window.EASYSHARE_PACKAGE_PLATFORMS || []).map((p) => `<option value="${p.code}">${p.zhName} / ${p.name}</option>`).join("")}
                    </select>
                    <p class="text-xs text-ink-500 mt-1.5">平台按中文 / 英文展示，保存时使用平台英文代码。</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="card overflow-hidden">
              <div class="px-5 py-4 border-b border-ink-100">
                <h3 class="text-sm font-semibold text-ink-900">应用标识与商店信息</h3>
                <p class="text-xs text-ink-500 mt-0.5">填写平台侧用于识别应用和承接分享跳转的关键信息。</p>
              </div>
              <div class="p-5 space-y-4">
                <div>
                  <label class="block text-sm font-medium text-ink-700 mb-1.5">Bundle ID / Package Name <span class="text-red-500">*</span></label>
                  <input id="package-bundle-id" type="text" required class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100" placeholder="如：com.kingsquest.ios" />
                  <p class="text-xs text-ink-500 mt-1.5">应用包名或 Bundle 标识，用于 SDK 初始化、平台匹配和包体识别。</p>
                </div>

                <div>
                  <label id="package-app-id-label" class="block text-sm font-medium text-ink-700 mb-1.5">App ID <span class="text-red-500">*</span></label>
                  <input id="package-app-id" type="text" required class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100" placeholder="iOS 填 Apple App ID；Google Play 填 Google Play App ID；其它三方平台填平台app Id" />
                  <p id="package-app-id-help" class="text-xs text-ink-500 mt-1.5">用于标识应用商店侧或三方平台侧的应用 ID，例如 Apple App ID、Google Play App ID 或平台app Id。</p>
                </div>

                <div>
                  <label class="block text-sm font-medium text-ink-700 mb-1.5">应用商店链接 <span class="text-red-500">*</span></label>
                  <input id="package-store-url" type="url" required class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100" placeholder="https://apps.apple.com/app/..." />
                  <p class="text-xs text-ink-500 mt-1.5">用户点击分享链接后的最终跳转地址（可在 Adapter 层针对桌面 / 移动做路由）。</p>
                </div>
              </div>
            </div>

            <div class="card px-5 py-4 flex items-center justify-between gap-4">
              <div class="text-xs text-amber-800 flex items-start gap-2">
                <span class="mt-0.5 w-4 h-4 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center text-[10px] font-bold">!</span>
                <div>同一游戏下，<strong>Region + 平台</strong>组合需要唯一。系统将自动校验是否重复。</div>
              </div>
              <div class="flex justify-end gap-2 flex-shrink-0">
                <button type="button" onclick="navigate('${cancelPath}')" class="px-4 py-2 border border-ink-200 rounded-lg text-sm hover:bg-ink-50">取消</button>
                <button type="submit" class="px-5 py-2 bg-brand-900 text-white rounded-lg text-sm font-medium hover:bg-brand-800">创建包体</button>
              </div>
            </div>
          </form>
        </div>

        <div class="col-span-4">
          <div class="card p-5 sticky top-4">
            <div class="flex items-start gap-2.5 mb-4">
              <div class="w-8 h-8 rounded-md bg-brand-50 border border-brand-100 flex items-center justify-center flex-shrink-0">
                ${Icon.info({ size: 16, color: "#1E3A8A" })}
              </div>
              <div>
                <h4 class="text-sm font-semibold text-ink-900">创建后会保存</h4>
                <p class="text-[11px] text-ink-500 mt-0.5">运营展示名称与包体级标识</p>
              </div>
            </div>

            <div class="space-y-3">
              <div class="border-l-2 border-brand-700 pl-3 py-1">
                <div class="text-xs font-semibold text-ink-900">Ripple ID</div>
                <div class="text-[11px] text-ink-500 mt-0.5">系统生成的 12 位强随机唯一标识，创建时自动校验唯一性</div>
                <div class="mt-1.5"><code class="text-[10px] font-mono px-1.5 py-0.5 bg-ink-100 rounded text-ink-600">p_8k2m9x0p3q7z</code></div>
              </div>
              <div class="border-l-2 border-ok-600 pl-3 py-1">
                <div class="text-xs font-semibold text-ink-900">包体名称</div>
                <div class="text-[11px] text-ink-500 mt-0.5">使用表单中录入的运营展示名称</div>
                <div class="mt-1.5"><code class="text-[10px] font-mono px-1.5 py-0.5 bg-ink-100 rounded text-ink-600">王者征途 US iOS 正式包</code></div>
              </div>
            </div>

            <div class="mt-5 pt-4 border-t border-ink-100 space-y-3">
              <div class="rounded-lg bg-brand-50 border border-brand-200 p-3 text-xs text-brand-900 leading-relaxed">
                <div class="font-semibold mb-1">凭证继承规则</div>
                同一款游戏下所有包体共用同一个 <code class="font-mono">GameID</code> 和 <code class="font-mono">Game Secret</code>，不会为包体单独生成 Secret。
              </div>
              <div class="rounded-lg bg-ink-50 border border-ink-200 p-3 text-xs text-ink-600 leading-relaxed">
                <div class="font-semibold text-ink-700 mb-1">下一步</div>
                <ol class="list-decimal pl-4 space-y-1">
                  <li>确认包体信息</li>
                  <li>接入 SDK</li>
                  <li>设置分享配置</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
};

// ---------- 创建包体表单：App ID 标签联动 ----------
window.updatePackageAppIdLabel = function (platformText) {
  const label = document.getElementById("package-app-id-label");
  const input = document.getElementById("package-app-id");
  const help = document.getElementById("package-app-id-help");
  if (!label || !input || !help) return;

  if (!platformText) {
    label.innerHTML = 'App ID <span class="text-red-500">*</span>';
    input.placeholder = "请填写对应应用商店或三方平台的 App ID";
    help.textContent = "用于标识应用商店侧或三方平台侧的应用 ID。";
    return;
  }
  const meta = typeof window.packagePlatformMeta === "function" ? window.packagePlatformMeta(platformText) : { code: platformText, name: platformText, zhName: platformText, appIdLabel: "平台 App ID" };
  label.innerHTML = `${meta.appIdLabel || "平台 App ID"} <span class="text-red-500">*</span>`;
  input.placeholder = meta.code === "APP_STORE" ? "如：1234567890" : "请填写该平台分配的应用 ID / 包名";
  help.textContent = `当前平台：${meta.zhName} / ${meta.name}（${meta.code}）。`;
};

window.submitPackageCreate = async function (event, fixedGameId, successPath) {
  event.preventDefault();
  const gameId = fixedGameId || document.getElementById("package-game-id")?.value;
  const packageName = document.getElementById("package-name")?.value.trim();
  const platformRaw = document.getElementById("package-platform")?.value || "";
  const bundleId = document.getElementById("package-bundle-id")?.value.trim();
  const appId = document.getElementById("package-app-id")?.value.trim();
  const storeUrl = document.getElementById("package-store-url")?.value.trim();

  if (!gameId || !packageName || !platformRaw || !bundleId || !appId || !storeUrl) {
    UI.toast("请补全必填字段", "error");
    return false;
  }

  if (window.__creatingPackage) return false;
  window.__creatingPackage = true;

  const { region, regionName } = getPackageCreateRegionFromSelection();
  const platform = typeof window.packagePlatformCode === "function" ? window.packagePlatformCode(platformRaw) : platformRaw;

  try {
    const { data: newPackage } = await packagesApi.create({
      game_id: gameId,
      name: packageName,
      region,
      region_name: regionName,
      platform,
      bundle_id: bundleId,
      app_id: appId,
      store_url: storeUrl,
      config_status: "draft",
    });
    await invalidateAndRefresh();
    const game = MOCK.GAMES.find(g => g.id === gameId);
    const id = newPackage.id;

    const result = {
      package: newPackage,
      game,
      creator: MOCK.ROLES[MOCK.SESSION.currentRole]?.user || "当前用户",
      createdAt: new Date(),
    };
    window.__newPackageResult = result;
    sessionStorage.setItem(`easyshare:newPackageResult:${id}`, JSON.stringify({
      package: newPackage,
      game,
      creator: result.creator,
      createdAt: result.createdAt.toISOString(),
    }));

    UI.toast("包体创建成功", "success");
    setTimeout(() => navigate(successPath || `/dev/packages/${id}/success`), 600);
  } catch (err) {
    UI.toast(err?.message || "创建失败", "error");
  } finally {
    window.__creatingPackage = false;
  }
  return false;
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).getPackageCreateRegionFromSelection = getPackageCreateRegionFromSelection;
;(window as any).getPackageCreateRegionSelection = getPackageCreateRegionSelection;
;(window as any).getPackageCreateRegionSummaryText = getPackageCreateRegionSummaryText;
